module.exports = __webpack_public_path__ + "fcc624178d0e0c259f91dfc0be1581de.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/main/images/cantons_treemap_desktop.svg
// module id = 140
// module chunks = 1